var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-chip',_vm._g({attrs:{"color":_vm.getColor(_vm.estado),"outlined":""}},on),[_vm._v(_vm._s(_vm.label))])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }